import type { DeviceSummary } from '@ghostscreen/contracts';
import { getScreenConnectionStatus } from '../screen-health';

export type FleetCounts = {
  online: number;
  offline: number;
  total: number;
};

/**
 * Fleet device counts using the same heartbeat rules as screen-health
 * (`getScreenConnectionStatus`). Unknown (missing/invalid/future heartbeat)
 * counts as not-online — same fail-soft posture as SQL `coalesce(..., false)`.
 */
export function deriveFleetCounts(devices: DeviceSummary[], now = new Date()): FleetCounts {
  const active = devices.filter((device) => device.status !== 'revoked');
  const online = active.filter(
    (device) =>
      getScreenConnectionStatus({ lastSeenAt: device.lastHeartbeatAt, now }) === 'online',
  ).length;
  return {
    online,
    offline: active.length - online,
    total: active.length,
  };
}
